<template>
  <div class="bg-white text-gray-800 mt-40">

    <!-- Titre principal -->
    <section class="py-8 px-6 text-center">
      <h1 class="text-4xl md:text-5xl uppercase font-extrabold mb-4 text-gray-900">
        Votre site vitrine en 5 minutes
      </h1>
      <p class="text-xl md:text-2xl font-medium text-gray-600">
        Un prix unique. Toutes les fonctionnalités. Zéro surprise.
      </p>
    </section>

    <!-- Switch Tarifs -->
    <section class="px-6 text-center ">
      <div class="flex justify-center mb-6 space-x-3 ">
        <button @click="plan = 'mensuel'" :class="plan === 'mensuel' ? activeBtn : inactiveBtn">
          Mensuel
        </button>
        <button @click="plan = 'annuel'" :class="plan === 'annuel' ? activeBtn : inactiveBtn">
          Annuel
        </button>
      </div>
    </section>

    <!-- Carte Tarifs -->
    <div class="max-w-lg mx-4 md:mx-auto bg-white rounded-3xl shadow-2xl border border-gray-200 p-8">
      <h2 class="text-2xl font-bold text-gray-900 mb-4">VOTRE ABONNEMENT <span
          class="font-handwritten text-primary">my</span><span class="text-primary"> Profolia</span></h2>

      <!-- Prix avec promo -->
      <div v-if="plan === 'mensuel'" class="mb-6 relative">

        <p class="text-4xl font-extrabold text-primary mt-1">
          5,99 € <span class="text-lg text-gray-500 font-normal">/ mois</span>
        </p>
        <p class="text-gray-600 mt-2 font-medium">Sans engagement. Résiliez quand vous voulez.</p>
      </div>

      <div v-else class="mb-6 relative">

        <p class="text-4xl font-extrabold text-primary mt-1">
          59,99 € <span class="text-lg text-gray-500 font-normal">/ an</span>
        </p>
        <p class="text-gray-600 mt-2 font-medium">Engagement 12 mois — Économisez 20 %</p>
      </div>

      <!-- Features -->
      <ul class="text-left space-y-2 mb-6">
        <li>✅ Logo + Nom de l’entreprise</li>
        <li>✅ Activité + secteur</li>
        <li>✅ Coordonnées + réseaux sociaux</li>
        <li>✅ Description, prestations et tarifs </li>
        <li>✅ Lien Réservation (Doctolib, Planity, etc.)</li>
        <li>✅ Adresse + Carte Google Maps</li>
        <li>✅ Horaires d’ouverture</li>
        <li>✅ Couleurs personnalisées</li>
        <li>✅ URL personnalisée</li>
        <li>✅ Support par email & réponse &lt; 48h</li>
      </ul>

      <router-link to="/subscribe"
        class="w-full bg-primary text-white py-4 rounded font-bold text-lg hover:scale-105 transition-transform shadow-lg inline-block text-center">
        S'abonner
      </router-link>
    </div>

    <!-- Section Prêt à lancer ta vitrine -->
    <section class="py-10 px-6 text-center bg-white my-20 min-h-[460px] mb-6">
      <h2 class="text-4xl font-extrabold text-black mb-6">🚀 Prêt à lancer ta vitrine ?</h2>
      <p class="max-w-3xl mx-auto text-lg text-gray-600 mb-12">
        En quelques clics, ta page pro est en ligne. Pas de surprise, pas de prise de tête.
      </p>

      <div class="bg-transparent">
        <div class="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-start gap-6 relative">

          <!-- Étape 1 -->
          <div
            class="flex-1 flex flex-col items-center bg-white border-2 border-primary text-black p-6 rounded-2xl shadow-lg hover:scale-105 transition-transform relative">
            <div class="flex items-center mb-4">
              <div
                class="w-14 h-14 flex items-center justify-center rounded-full bg-primary text-white font-extrabold text-xl mr-4 shadow-md">
                1
              </div>
              <h3 class="font-bold text-xl">Remplis tes infos</h3>
            </div>
            <p class="text-center">Ajoute ton logo, ton nom, ton secteur, tes horaires, ton adresse, etc.</p>
            <div
              class="hidden md:block absolute right-0 top-1/2 transform translate-x-full -translate-y-1/2 w-12 h-1 bg-primary rounded-full">
            </div>
          </div>

          <!-- Étape 2 -->
          <div
            class="flex-1 flex flex-col items-center bg-white border-2 border-primary text-black p-6 rounded-2xl shadow-lg hover:scale-105 transition-transform relative">
            <div class="flex items-center mb-4">
              <div
                class="w-14 h-14 flex items-center justify-center rounded-full bg-primary text-white font-extrabold text-xl mr-4 shadow-md">
                2
              </div>
              <h3 class="font-bold text-xl">Choisis ton tarif</h3>
            </div>
            <p class="text-center">Mensuel ou annuel, tout est transparent et sans surprise.</p>
            <div
              class="hidden md:block absolute right-0 top-1/2 transform translate-x-full -translate-y-1/2 w-12 h-1 bg-primary rounded-full">
            </div>
          </div>

          <!-- Étape 3 -->
          <div
            class="flex-1 flex flex-col items-center bg-white border-2 border-primary text-black p-6 rounded-2xl shadow-lg hover:scale-105 transition-transform relative">
            <div class="flex items-center mb-4">
              <div
                class="w-14 h-14 flex items-center justify-center rounded-full bg-primary text-white font-extrabold text-xl mr-4 shadow-md">
                3
              </div>
              <h3 class="font-bold text-xl">Ta page est en ligne</h3>
            </div>
            <p class="text-center">Partage ton site immédiatement et commence à attirer des clients.</p>
          </div>

        </div>
      </div>

    </section>

    <!-- FAQ Stylée -->
    <section class="py-16 px-6 bg-primary-light">
      <h2 class="text-4xl font-extrabold text-center mb-12">FAQ - Questions fréquentes</h2>

      <div class="max-w-3xl mx-auto space-y-4">
        <div v-for="(item, index) in faqItems" :key="index"
          class="border-2 border-primary-light rounded-2xl overflow-hidden shadow hover:shadow-lg transition-shadow duration-300">
          <button @click="toggle(index)"
            class="w-full text-left px-6 py-4 flex justify-between items-center bg-white hover:bg-white transition-colors duration-300"
            :class="{ 'border-b border-primary-light': openIndex === index }">
            <span class="font-semibold text-gray-800 text-lg md:text-xl">{{ item.question }}</span>
            <span class="text-2xl font-bold text-purple-600 transform transition-transform duration-300"
              :class="{ 'rotate-45 scale-110': openIndex === index }">
              +
            </span>
          </button>

          <transition name="accordion">
            <div v-show="openIndex === index"
              class="px-6 py-2 bg-white text-gray-700 text-base md:text-lg leading-relaxed" v-html="item.answer"></div>
          </transition>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const plan = ref('mensuel')
const openIndex = ref(null)

const activeBtn = "px-12 md:px-20 py-2 rounded font-semibold text-white bg-primary shadow uppercase"
const inactiveBtn = "px-12 md:px-20 py-2 rounded font-semibold text-primary border border-violet-500 bg-white uppercase"

const faqItems = [
  {
    question: "Quels sont les modes de paiement acceptés ?",
    answer: "Nous acceptons tous les paiements sécurisés : cartes bancaires Visa et Mastercard via Stripe, une solution reconnue mondialement. Votre paiement est entièrement sécurisé."
  },
  {
    question: "Combien coûte MyProfolia ?",
    answer: "Notre Formule Unique coûte :<br>• 5,99 € / mois sans engagement<br>• 59,99 € / an avec engagement 12 mois (soit une économie de 20 %)<br>Aucun frais caché : tout est inclus dans l’abonnement."
  },
  {
    question: "Le paiement est-il sécurisé ?",
    answer: "Oui. Nous utilisons Stripe, une solution fiable et sécurisée pour protéger vos informations bancaires."
  },
  {
    question: "Que se passe-t-il après le paiement ?",
    answer: "Dès validation :<br>• Votre page vitrine est publiée immédiatement<br>• Vous pouvez modifier vos informations, photos et tarifs à tout moment<br>• Vous recevez une confirmation par email"
  },
  {
    question: "Y a-t-il des frais supplémentaires ou cachés ?",
    answer: "Non. L’hébergement, la sécurité, les modifications illimitées et le support client sont inclus dans le prix affiché."
  },
  {
    question: "Puis-je résilier mon abonnement ?",
    answer: "Oui, à tout moment depuis votre espace client :<br>• Abonnement mensuel : résiliation immédiate, prend fin à la fin du mois en cours, sans frais supplémentaires<br>• Abonnement annuel : résiliation possible à la fin de l’engagement de 12 mois"
  },
  {
    question: "Que faire en cas de problème avec le paiement ?",
    answer: "Contactez-nous immédiatement via le formulaire ou par email à <a href='mailto:contact@myprofolia.com' class='text-purple-600 underline'>contact@myprofolia.com</a>. Nous résolvons rapidement tout problème de facturation ou de paiement."
  }
]

const toggle = (index) => {
  openIndex.value = openIndex.value === index ? null : index
}
</script>
